import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import axios from 'axios';

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get('https://api.safenetbanking.com/api/users/user_dashboard', {
      headers: { Authorization: 'Bearer ' + token }
    }).then(res => setUsers([res.data])); // wrap in array for table rendering
  }, []);
  return (
    <Box>
      <Typography variant="h4" mb={3}>Users</Typography>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Account #</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map(u => (
              <TableRow key={u.id}>
                <TableCell>{u.full_name}</TableCell>
                <TableCell>{u.email}</TableCell>
                <TableCell>{u.account_number}</TableCell>
                <TableCell>{u.created_at}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
